export default "__VITE_ASSET__CkutAR4___"